import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await login(email, password);
    if (result.success) {
      navigate(result.redirect || '/');
    } else {
      if (result.redirect) navigate(result.redirect);
      else { setError(result.error); setLoading(false); }
    }
  };

  return (
    <div className="lp-root">
      {/* LEFT — background image + branding */}
      <div className="lp-left">
        <div className="lp-left-inner">
          {/* Brand */}
          <div className="lp-brand">
            <div className="lp-logo">🏗</div>
            <span className="lp-brand-name">Construction ERP</span>
          </div>

          {/* Hero */}
          <div className="lp-hero">
            <h2 className="lp-welcome">Welcome to Construction ERP</h2>

            <div className="lp-features-grid">
              <div className="lp-feature-item">
                <span className="lp-check">✓</span>
                <div>
                  <strong>Project &amp; Site Management</strong>
                  <span>Track progress, timelines and budgets across all sites</span>
                </div>
              </div>
              <div className="lp-feature-item">
                <span className="lp-check">✓</span>
                <div>
                  <strong>Employee &amp; Payroll</strong>
                  <span>Manage attendance, salaries and HR records effortlessly</span>
                </div>
              </div>
              <div className="lp-feature-item">
                <span className="lp-check">✓</span>
                <div>
                  <strong>Enquiries &amp; CRM</strong>
                  <span>Convert leads to customers and projects seamlessly</span>
                </div>
              </div>
              <div className="lp-feature-item">
                <span className="lp-check">✓</span>
                <div>
                  <strong>Vendors &amp; Expenses</strong>
                  <span>Control procurement, payments and cost tracking</span>
                </div>
              </div>
              <div className="lp-feature-item">
                <span className="lp-check">✓</span>
                <div>
                  <strong>Reports &amp; Analytics</strong>
                  <span>Real-time dashboards with actionable business insights</span>
                </div>
              </div>
              <div className="lp-feature-item">
                <span className="lp-check">✓</span>
                <div>
                  <strong>Multi-Branch Support</strong>
                  <span>Manage multiple locations under one unified account</span>
                </div>
              </div>
            </div>

            {/* Support — right after features */}
            <div className="lp-support">
              <p className="lp-support-label">Need help or have a query?</p>
              <a
                href="https://oleocotech.com/#contact"
                target="_blank"
                rel="noopener noreferrer"
                className="lp-support-btn"
              >
                Contact Support →
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* RIGHT — form */}
      <div className="lp-right">
        <div className="lp-card">
          {/* Card logo + brand */}
          <div className="lp-card-brand">
            <div className="lp-card-logo">🏗</div>
            <span className="lp-card-brand-name">Construction ERP</span>
          </div>

          <div className="lp-card-header">
            <h2 className="lp-card-title">Sign in</h2>
            <p className="lp-card-sub">Enter your credentials to continue</p>
          </div>

          {error && <div className="lp-error">{error}</div>}

          <form onSubmit={handleSubmit} className="lp-form">
            <div className="lp-field">
              <label htmlFor="lp-email">Email address</label>
              <input
                id="lp-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
                required
                disabled={loading}
                autoComplete="email"
              />
            </div>

            <div className="lp-field">
              <div className="lp-label-row">
                <label htmlFor="lp-password">Password</label>
                <Link to="/forgot-password" className="lp-forgot">Forgot password?</Link>
              </div>
              <input
                id="lp-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                disabled={loading}
                autoComplete="current-password"
              />
            </div>

            <button type="submit" className="lp-submit" disabled={loading}>
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
          </form>

          <p className="lp-register-row">
            Don't have an account?{' '}
            <Link to="/register" className="lp-link">Register your company</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
